import React from 'react'
import { connect } from 'react-redux'
import { Modal } from 'reactstrap'

import { closeModal } from '../reducers/modals'

class _ModalContainer extends React.Component {
  render() {
    const { Component, componentProps, dispatch } = this.props

    return (
      <Modal
        isOpen={!!Component}
        toggle={() => dispatch(closeModal())}
        className={`ModalContainer-${Component && Component.name}`}
      >
        {Component && <Component dispatch={dispatch} {...componentProps} />}
      </Modal>
    )
  }
}

const ModalContainer = connect((state) => {
  return {
    Component: state.modals.active ? require(`./modals/${state.modals.active}`).default : null,
    componentProps: state.modals.props,
  }
})(_ModalContainer)

export default ModalContainer
